export enum StatusNotification {
  Unread = 0,
  Read = 1,
}
